import React from 'react';
import closepopup from '../../styles/img/promo/closepopup.svg';

export function Popin({ children, zIndex, height, width, className, onClose }) {
  return (
    <div className="popin" style={{ zIndex: zIndex ?? 100 }}>
      <div className="popin-mask" onClick={onClose} />
      <div
        className={`popin-container ${className || ''}`}
        style={{ height, width }}
      >
        {!!onClose && (
          <div className="close-btn" onClick={onClose}>
            <img src={closepopup} alt="" />
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
